// import useUserStore from '@/store/modules/user';

const pageEventFindConfig: {
  eventId: string,
  testLastStr?: string,
  testReg?: RegExp,
  testFunc?: (findUrl: string, triggerPageUrl?: string) => string | undefined
}[] = [
  {
    eventId: '1001',
    testReg: /\/home/
  },
  {
    eventId: '1007',
    testReg: /\/rules/
  },
  {
    eventId: '1008',
    testReg: /\/aboutus/
  },
  {
    eventId: '1009',
    testReg: /\/dataview\/data-space/
  }
];
const eventIdMap = {};

const getEventIdByConfig = (findUrl, config, triggerPageUrl) => {
  const testLastStr = config.testLastStr;
  const testFunc = config.testFunc;
  const testReg = config.testReg;
  let eventId = '';
  if (testFunc) {
    eventId = testFunc(findUrl, triggerPageUrl);
  } else if (testLastStr) {
    // 最后位置匹配
    if (findUrl.indexOf(testLastStr) + testLastStr.length === findUrl.length) {
      eventId = config.eventId;
    }
  } else if (testReg) {
    if (testReg.test(findUrl)) {
      eventId = config.eventId;
    }
  }
  return eventId;
};

const fixDataFuncMap = {
  // '1002': (item) => {
  //   item.eventId = '1002';
  // }
};
const getEventId = (item) => {
  const distEventId = item.distEventId;
  if (distEventId) return distEventId
  const sourceEventId = item.eventId;
  if (eventIdMap[item.eventId]) return eventIdMap[sourceEventId];
  const triggerPageUrl = item.triggerPageUrl;
  const findUrl = (item.triggerPageUrl || '').split('?')[0];
  for (let i = 0; i < pageEventFindConfig.length; i++) {
    const config = pageEventFindConfig[i];
    const eventId = getEventIdByConfig(findUrl, config, triggerPageUrl);
    if (eventId) {
      // if (!config.testFunc) {
      //   eventIdMap[sourceEventId] = eventId;
      // }
      return eventId;
    }
  }
};
const pvFix = (item) => {
  delete item.title;
  delete item.params;
  const eventId = getEventId(item);
  if(item.action === 'reload') return item;
  console.log('item', item.triggerPageUrl, eventId)
  if (eventId) {
    item.eventId = eventId;
    if (fixDataFuncMap[eventId]) {
      fixDataFuncMap[eventId](item);
    }
    item._finalAdd = true;
  } else {
    item._finalAdd = false;
  }
  return item;
};

export default pvFix;
